<div class="preview">
  @for (url of [imageUrl]; track url) {
    @if (url && !failed) {
      <img hidden
        [src]="url"
        alt=""
        (load)="imageLoaded($event, sprite)"
        (error)="imageFailed()">
      <canvas #sprite class="sprite"
        [class.loaded]="loaded"
        role="img"
        [attr.aria-label]="name"
        [style.animation-duration.s]="duration"
        [style.animation-timing-function]="'steps(' + frameCount + ')'"
        [style.animation-play-state]="playing ? 'running' : 'paused'">
        {{name}}
      </canvas>
    }
  }
  @if (!loaded) {
    <span class="preview-state" role="status">
      {{failed || !imageUrl ? 'Preview unavailable' : 'Loading preview…'}}
    </span>
  }
</div>
